var _nodeResolve_empty = {};

export { _nodeResolve_empty as default };
